import { render, staticRenderFns } from "./UiDialog.vue?vue&type=template&id=2aeadb81"
import script from "./UiDialog.vue?vue&type=script&lang=ts"
export * from "./UiDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports